import { Dispatch, SetStateAction, createContext } from "react";

import { LocationDetail } from "@/types/location";
import { ProviderSummary } from "@/types/provider";

export interface UserContextProps {
  currentUser: ProviderSummary | null | undefined;
  setCurrentUser: Dispatch<SetStateAction<ProviderSummary | null | undefined>>;
  refetchUser: (tenant?: string) => Promise<void>;
  currentLocationId: string | null;
  updatePrimaryLocation: (locationId: string | null) => Promise<boolean>;
  visibleLocationIds: string[];
  refetchVisibleLocations: () => Promise<void>;
  locationSuggestion: {
    show: boolean;
    location: LocationDetail | null;
    distance: number;
  };
  dismissLocationSuggestion: () => void;
  acceptLocationSuggestion: () => Promise<void>;
}

export const UserContext = createContext<UserContextProps | null>(null);
